export function getFormatted(jobCount) {
	const formattedNumber = new Intl.NumberFormat('en-US',
		{style: 'decimal', maximumFractionDigits: 0}).format(jobCount);
	return formattedNumber
}

export function capitalizeFirst(word) {
	return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
}

export function getBoundingBox(lat, lng, distanceInMiles) {
	const earthRadius = 3958.8;
	
	// Distance in degrees = Distance in radians * (180 / PI)
	const distanceInDegreesLat = (distanceInMiles / earthRadius) * (180 / Math.PI);
	
	// Correction for longitude distance calculation
	const radiusAtLat = earthRadius * Math.cos(lat * Math.PI / 180);
	const distanceInDegreesLng = (distanceInMiles / radiusAtLat) * (180 / Math.PI);
	
	// Calculate bounding box corners
	const north = lat + distanceInDegreesLat;
	const south = lat - distanceInDegreesLat;
	const east = lng + distanceInDegreesLng;
	const west = lng - distanceInDegreesLng;
	
	// Return SW and NE corners of the bounding box
	return [[south, west], [north, east]];
}

export function isOffsiteJob(record) {
	if ('isoffsitejobflag' in record) {
		if (record.isoffsitejobflag) {
			return record.isoffsitejobflag.toString()
		}
	}
	return '-'
}

export function isRemoteJob(record) {
	if ('isremotejobflag' in record) {
		if (record.isremotejobflag) {
			return record.isremotejobflag.toString()
		}
	}
	return '-'
}

export function getLocationsInfo(record) {
	if ('locations' in record) {
		const locs = record.locations
		if (Array.isArray(locs)) {
			return locs.map(loc => capitalizeFirst(loc)).join(', ')
		} else {
			return capitalizeFirst(locs);
		}
	} else {
		return '-'
	}
}

export function getLatLongs(record) {
	if ('latlongs' in record) {
		const latlongs = record.latlongs
		return latlongs
	} else {
		return '-'
	}
}


export function getDatePosted(record) {
	if ('date_posted' in record) {
		return record['date_posted']
	} else {
		return '-'
	}
}

export function getTitleText(record) {
	if ('title' in record) {
		return record.title
	}
	return '-'
}

export function extractCompanyName(url) {
	let hostname = ''
	try {
		hostname = new URL(url).hostname;
	} catch {
		return '-'
	}
	if (url.includes('Samsung')) {
		return 'Samsung'
	}
	if (hostname.includes('intel')) {
		return capitalizeFirst('intel')
	}
	if (hostname.includes('zebra')) {
		return capitalizeFirst('zebra')
	}
	if (hostname.includes('t-mobile')) {
		return capitalizeFirst('tmobile')
	}
	if (hostname.includes('comcast')) {
		return capitalizeFirst('comcast')
	}
	if (hostname.includes('cisco')) {
		return capitalizeFirst('cisco')
	}
	if (hostname.includes('verizon')) {
		return capitalizeFirst('verizon')
	}
	if (hostname.includes('fa-evmr-saasfaprod1.fa.ocs')) {
		return capitalizeFirst('Nokia')
	}
	if (hostname.includes('americantower')) {
		return capitalizeFirst('americantower')
	}
	if (hostname.includes('assurant')) {
		return capitalizeFirst('assurant')
	}
	if (hostname.includes('qualcomm')) {
		return capitalizeFirst('qualcomm')
	}
	if (hostname.includes('netflix')) {
		return capitalizeFirst('netflix')
	}
	
	if (hostname.includes('ebay')) {
		return capitalizeFirst('eBay')
	}
	
	if (hostname.includes('apple')) {
		return capitalizeFirst('apple')
	}
	if (hostname.includes('walmart')) {
		return capitalizeFirst('walmart');
	}
	try {
		const parts = hostname.split('.');
		const companyName = parts[0] === 'www' ? parts[1] : parts[0];
		return capitalizeFirst(companyName)
	} catch {
		return '-'
	}
}
